/**
 * External dependencies
 */
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { noop } from "lodash";

/**
 * Internal dependencies
 */

import FormLabel from "components/forms/form-label";
import { saveReport } from "state/reports/actions";
import { getReportId } from "state/ui/report-rename-form/selectors";
import useInput from "hooks/use-input";
import { getReport } from "state/reports/selectors";
import { ButtonV2 } from "components/button-v2";
import { Text } from "components/text";

/**
 * Style dependencies
 */
import "./styles.scss";

const RenameReportForm = ({
  data = {},
  reportId,
  afterSave = noop,
  onCancel = noop,
  ...props
}) => {
  const { value, bind } = useInput("name", data.name);
  const [isSaving, setSaving] = useState(false);
  const nameInput = useRef(null);
  const isDisabled = isSaving || value.length <= 0;

  useEffect(() => {
    nameInput.current.focus();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await props.saveReport(reportId, { name: value });
      afterSave(reportId, { name: value });
    } catch (e) {}
    setSaving(false);
  };

  return (
    <form onSubmit={handleSave} className="flex p-6 flex-col ">
      <div>
        <Text variant="headingXxs" className="mb-4 ">
          View name
        </Text>
        <input type="text" autoComplete="off" ref={nameInput} {...bind} />
      </div>
      <div className="flex gap-3 mt-6 ">
        <ButtonV2
          disabled={isDisabled}
          fullWidth
          type="submit"
          variant="primary"
        >
          Rename
        </ButtonV2>
        <ButtonV2 fullWidth onClick={() => onCancel()}>
          Cancel
        </ButtonV2>
      </div>
    </form>
  );
};

export default connect(
  (state) => {
    let reportId = getReportId(state);
    let report = getReport(state, reportId) || {};
    return {
      reportId,
      data: { name: report && report.name },
    };
  },
  { saveReport },
)(RenameReportForm);
